"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphaDesignatorToIndex = alphaDesignatorToIndex;
exports.isAlphaDesignator = isAlphaDesignator;
exports.indexToAlphaDesignator = indexToAlphaDesignator;
function alphaDesignatorToIndex(alpha) {
    if (!isAlphaDesignator(alpha)) {
        throw new Error(`Invalid alphabetic designator: ${alpha}`);
    }
    return alpha.split('').reduce((p, c) => p * 26 + c.charCodeAt(0) - 'A'.charCodeAt(0) + 1, 0);
}
function isAlphaDesignator(designator) {
    return /^[A-Z]+$/.test(designator);
}
function indexToAlphaDesignator(index) {
    if (!Number.isInteger(index) || index < 1) {
        throw new Error(`Invalid 1-based alphabetic designator index: ${index}`);
    }
    let remaining = index;
    let designator = '';
    while (remaining > 0) {
        remaining--;
        designator = String.fromCharCode('A'.charCodeAt(0) + (remaining % 26)) + designator;
        remaining = Math.floor(remaining / 26);
    }
    return designator;
}
//# sourceMappingURL=alphaDesignatorToConstant.js.map